<template>
	<div>
		<ProgressLinear v-if="loading"/>
		<v-alert dense class="mx-3 mt-3" type="error" v-if="error_msg.length !== 0">
			{{ errorMessageFormat(error_msg) }}
		</v-alert>
		<template v-if="!loading">
			<v-row class="mx-4 mt-5 mb-0" :justify="$vuetify.breakpoint.smAndUp ? 'space-between':'start'" align="center">
				<div>
					<span class="file-list-title" style="color: #4742C6">No Holdings&nbsp;</span>
					<span class="file-list-text" style="color: #F45252; font-size: 16px; font-weight: 700;">&nbsp;{{ no_holding_list.length }}&nbsp;new</span>
				</div>
				<v-row class="ma-0 py-1" justify="end" align="center">
					<v-menu v-model="filter_menu_visible" offset-y :close-on-content-click="false">
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								:style="isFilterDiff ? 'border: 1px solid #605AF6':''"
								class="text-capitalize px-3"
								color="#FAFAFA"
								max-height="32"
								min-height="32"
								v-bind="attrs"
								v-on="on"
							>
								<v-icon color="#82899B" size="20" class="mr-2">mdi-filter-variant</v-icon>
								<span class="mr-3 font-bold-style" style="color: rgba(25, 42, 62, 0.7)">Filters</span>
								<v-icon v-if="!filter_menu_visible" color="rgba(25, 42, 62, 0.7)">mdi-chevron-down</v-icon>
								<v-icon v-else color="rgba(25, 42, 62, 0.7)">mdi-chevron-up</v-icon>
							</v-btn>
						</template>
						<div class="filter-menu-wrap mt-1" @click.stop>
							<div class="px-3 pt-3 pb-0">
								<v-checkbox
									v-model="is_positive_value"
									class="filter-menu-checkbox"
									:color="color"
									hide-details
								>
									<template v-slot:label>
										<span class="filter-menu-label">Supplier rate > $0</span>
									</template>
								</v-checkbox>
							</div>
						</div>
					</v-menu>
					<v-menu offset-y :close-on-content-click="false">
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								:style="isColumnDiff ? 'border: 1px solid #605AF6':''"
								class="text-capitalize ml-4 px-3"
								color="#FAFAFA"
								max-height="32"
								min-height="32"
								v-bind="attrs"
								v-on="on"
								@click="is_down = !is_down"
							>
								<ColumnsTable :color="'#82899B'" width="20" height="20" class="mr-2"/>
								<span class="mr-3 font-bold-style" style="color: rgba(25, 42, 62, 0.7)">Columns</span>
								<v-icon v-if="is_down" color="rgba(25, 42, 62, 0.7)">mdi-chevron-down</v-icon>
								<v-icon v-if="!is_down" color="rgba(25, 42, 62, 0.7)">mdi-chevron-up</v-icon>
							</v-btn>
						</template>
						<div style="min-width: 226px;height: 68vh;background-color: white;">
							<div class="tree-wrap">
								<div class="tree-wrap-container" style="background-color: white" v-for="item in columns" :key="item.value">
									<v-list-item dense>
										<v-checkbox
											class="mt-0 pt-0"
											v-model="select_columns"
											:label="item.text"
											:value="item"
											:color="color"
											dense
											hide-details
											@change="onSelectColumn()"
										></v-checkbox>
									</v-list-item>
								</div>
							</div>
						</div>
					</v-menu>
				</v-row>
			</v-row>
			<v-expansion-panels v-model="panel" flat accordion readonly>
				<v-expansion-panel
					v-for="(detail, i) in panel_details"
					:key="i"
				>
					<v-expansion-panel-header class="no-header-hover" style="padding: 0 16px; align-items: flex-start; min-height: 48px;">
						<v-row class="panel-header font-bold-style ma-0" style="line-height: 36px;">
							<div class="my-1 px-1 panel-toggle-target" style="background-color: #FAFAFA; height: 40px" :style="`color: ${color}`" @click.stop="togglePanel(i)">{{ detail.job.job_code }} - {{ detail.job.job_title }}</div>
							<v-menu
								:key="detail.id"
								v-model="detail.menu"
								:close-on-content-click="false"
								offset-y
								min-width="auto"
								@click.stop
							>
								<template v-slot:activator="{ on, attrs }">
									<v-row v-bind="attrs" v-on="on" class="mx-4 my-1 px-3 panel-toggle-target" style="max-width: 160px; background-color: #FAFAFA; flex-wrap: nowrap;" align="center">
										<div style="width: 24px; height: 28px">
											<Calendar :color="'rgba(25, 42, 62, 0.5)'" width="20" height="20"/>
										</div>
										<div class="font-bold-style">{{ getDateText(detail.date) }}</div>
									</v-row>
								</template>
								<v-card @click.stop>
									<v-date-picker
										v-model="detail.date"
										:color="color"
										:picker-date.sync="detail.month"
										no-title
										multiple
										scrollable
										range
										@change="onDateChange($event, detail.id)">
									</v-date-picker>
									<v-row class="ma-0">
										<v-btn text class="text-capitalize" :color="color" @click.stop="onLastWeek(detail.id)">Last week</v-btn>
									</v-row>
									<v-row class="ma-0">
										<v-btn text class="text-capitalize" :color="color" @click.stop="onLastMonth(detail.id)">Last month</v-btn>
									</v-row>
								</v-card>
							</v-menu>
							<v-btn
								class="panel-toggle-target white--text text-capitalize px-2 mr-4 my-1"
								:color="'#EE0202'"
								:disabled="detail.active_num === 0"
								max-height="40"
								min-height="40"
								@click.stop="onDelete(detail)"
							>
								<v-icon size="24" class="mr-1">mdi-delete-outline</v-icon>
								<span class="font-bold-style">Delete/Reverse Bookings ({{ detail.active_num }})</span>
							</v-btn>
							<v-btn
								class="panel-toggle-target white--text text-capitalize px-2 my-1"
								:color="color"
								:disabled="detail.active_num === 0"
								max-height="40"
								min-height="40"
								@click.stop="onCopySelected()"
							>
								<v-icon size="22" class="mr-1">mdi-content-copy</v-icon>
								<span class="button-text">Copy selected ({{ detail.active_num }})</span>
							</v-btn>
						</v-row>
						<template v-slot:actions>
							<v-row class="panel-icon panel-toggle-target mt-2 mx-0 mb-0 px-2" style="background-color: #FAFAFA; height: 40px;" @click.stop="togglePanel(i)">
								<v-icon v-if="is_down" :color="color">mdi-chevron-up</v-icon>
								<v-icon v-if="!is_down" :color="color">mdi-chevron-down</v-icon>
							</v-row>
						</template>
					</v-expansion-panel-header>
					<v-expansion-panel-content>
						<v-data-table
							:headers="headers"
							:items="detail['holdings']"
							:items-per-page="countPerpage"
							:page.sync="page"
							item-key="id"
							hide-default-header
							hide-default-footer
						>
							<template v-slot:header="{ props: { headers } }">
								<thead>
									<tr>
										<th v-for="header in headers" :key="header.value" class="header-background-color" :class="{ 'sticky-checkbox-column': header.value === 'checkbox' }">
											<v-row class="ma-0 px-3 table-header-row">
												<v-checkbox
													v-if="header.value === 'checkbox'"
													v-model="detail.check"
													:color="color"
													@change="onCheckBoxAll($event, detail.id)"
												>
												</v-checkbox>
												<span class="font-bold-style font-header-style">{{ header.text }}&nbsp;</span>
											</v-row>
										</th>
									</tr>
								</thead>
							</template>
							<template v-slot:body="{ items, headers }">
								<tbody>
									<template v-if="items.length === 0">
										<tr>
											<td :colspan="headers.length">
												<v-row class="font-normal-style font-header-style ma-0 px-3" justify="center" style="line-height: 48px">
													<div>&nbsp;&nbsp;</div>
												</v-row>
											</td>
										</tr>
									</template>
									<template v-else>
										<tr v-for="(item_obj, index) in items" :key="index" style="background-color: #FAFAFF;">
											<td v-for="(item, key) in filterItem(item_obj)" :key="key" :class="{ 'sticky-checkbox-column sticky-checkbox-cell': key === 'checkbox' }">
												<div v-if="key === 'checkbox'" class="holding-cell holding-cell-checkbox">
													<v-row justify="start" class="font-bold-style font-header-style mx-0 px-3" style="flex-wrap: nowrap; line-height: 48px">
														<v-checkbox
															v-model="item_obj.checkbox"
															:color="color"
															@change="onCheckBox(detail.id)"
														></v-checkbox>
													</v-row>
												</div>
												<div v-if="key === 'phase_desc'" class="holding-cell">
													<v-row justify="start" align="center" class="font-bold-style font-header-style mx-0 px-3" style="flex-wrap: nowrap; height: 48px">
														<span class="long-text font-normal-style">{{ item }}</span>
													</v-row>
												</div>
												<div v-if="key === 'outlet'" class="holding-cell">
													<v-row justify="start" align="center" class="font-bold-style font-header-style mx-0 px-3" style="flex-wrap: nowrap; height: 48px">
														<span class="long-text font-normal-style">{{ item ? item.display_name : '' }}</span>
													</v-row>
												</div>
												<div v-if="key === 'kind'" class="holding-cell">
													<v-row justify="start" align="center" class="font-normal-style font-header-style ma-0 px-3" style="flex-wrap: nowrap; height: 48px">
														<span class="long-text font-normal-style">{{ item ? item.display_name : '' }}</span>
													</v-row>
												</div>
												<div v-if="key === 'station'" class="holding-cell">
													<v-row justify="start" align="center" class="font-bold-style font-header-style mx-0 px-3" style="flex-wrap: nowrap; height: 48px">
														<v-card tile elevation="0" color="transparent">
															<span class="font-normal-style truncate-2">{{ item ? `${item.station_code} - ${item.station_desc}` : '' }}</span>
														</v-card>
													</v-row>
												</div>
												<div v-if="key === 'media_reference_id'" class="holding-cell">
													<v-row justify="start" align="center" class="font-bold-style font-header-style mx-0 px-3" style="flex-wrap: nowrap; height: 48px">
														<span class="font-normal-style">{{ item }}</span>
														<v-btn v-if="item" icon small class="ml-3" @click.stop="onHistoryClick(item)">
															<v-icon color="rgba(25, 42, 62, 0.25)" size="22">mdi-history</v-icon>
														</v-btn>
													</v-row>
												</div>
												<div v-if="key === 'contract_ref'" class="holding-cell">
													<v-row justify="start" align="center" class="font-bold-style font-header-style mx-0 px-3" style="flex-wrap: nowrap; height: 48px">
														<span class="font-normal-style">{{ item }}</span>
													</v-row>
												</div>
												<div v-if="key === 'booking_start'" class="holding-cell">
													<v-row justify="start" align="center" class="font-bold-style font-header-style mx-0 px-3" style="flex-wrap: nowrap; height: 48px">
														<span class="font-normal-style">{{ formatDate(item) }}</span>
													</v-row>
												</div>
												<div v-if="key === 'booking_day_flags'" class="holding-cell">
													<v-row justify="start" align="center" class="font-bold-style font-header-style mx-0 px-3" style="flex-wrap: nowrap; height: 48px">
														<span v-for="(flag, index) in item" :key="index" class="font-normal-style mr-1" style="color:#605AF6">{{ flag === '1' ? week_flag[index]: '-' }}&nbsp;</span>
													</v-row>
												</div>
												<div v-if="key === 'duration'" class="holding-cell">
													<v-row justify="start" align="center" class="font-bold-style font-header-style mx-0 px-3" style="flex-wrap: nowrap; height: 48px">
														<span class="font-normal-style">{{ item }}</span>
													</v-row>
												</div>
												<div v-if="key === 'booking_start_time'" class="holding-cell">
													<v-row justify="start" align="center" class="font-bold-style font-header-style mx-0 px-3" style="flex-wrap: nowrap; height: 48px">
														<span class="font-normal-style">{{ item }}</span>
													</v-row>
												</div>
												<div v-if="key === 'booking_end_time'" class="holding-cell">
													<v-row justify="start" align="center" class="font-bold-style font-header-style mx-0 px-3" style="flex-wrap: nowrap; height: 48px">
														<span class="font-normal-style">{{ item }}</span>
													</v-row>
												</div>
												<div v-if="key === 'rate_fc'" class="holding-cell">
													<v-row justify="start" align="center" class="font-bold-style font-header-style mx-0 px-3" style="flex-wrap: nowrap; height: 48px">
														<span class="font-normal-style mr-1">{{ item_obj.cost_currency.symbol }}</span>
														<span class="font-normal-style">{{ formatNumber(item) }}</span>
													</v-row>
												</div>
												<div v-if="key === 'value_fc'" class="holding-cell">
													<v-row justify="start" align="center" class="font-bold-style font-header-style mx-0 px-3" style="flex-wrap: nowrap; height: 48px">
														<span class="font-normal-style mr-1">{{ item_obj.value_currency.symbol }}</span>
														<span class="font-normal-style">{{ formatNumber(item) }}</span>
													</v-row>
												</div>
												<div v-if="key === 'program_name'" class="holding-cell">
													<v-row justify="start" align="center" class="font-bold-style font-header-style mx-0 px-3" style="flex-wrap: nowrap; height: 48px">
														<span class="long-text font-normal-style">{{ item }}</span>
													</v-row>
												</div>
												<div v-if="key === 'pos_in_break'" class="holding-cell">
													<v-row justify="start" align="center" class="font-bold-style font-header-style mx-0 px-3" style="flex-wrap: nowrap; height: 48px">
														<span class="long-text font-normal-style">{{ item }}</span>
													</v-row>
												</div>
												<div v-if="key === 'material_key_identifier'" class="holding-cell">
													<v-row justify="start" align="center" class="font-bold-style font-header-style mx-0 px-3" style="flex-wrap: nowrap; height: 48px">
														<span class="long-text font-normal-style">{{ item }}</span>
													</v-row>
												</div>
												<div v-if="key === 'priority_modifier'" class="holding-cell">
													<v-row justify="start" align="center" class="font-bold-style font-header-style mx-0 px-3" style="flex-wrap: nowrap; height: 48px">
														<span class="long-text font-normal-style">{{ item }}</span>
													</v-row>
												</div>
												<div v-if="key === 'custom1'" class="holding-cell">
													<v-card tile elevation="0" color="transparent">
														<span class="font-normal-style truncate-2">{{ item }}</span>
													</v-card>
												</div>
												<div v-if="key === 'custom2'" class="holding-cell">
													<v-card tile elevation="0" color="transparent">
														<span class="font-normal-style truncate-2">{{ item }}</span>
													</v-card>
												</div><div v-if="key === 'custom3'" class="holding-cell">
													<v-card tile elevation="0" color="transparent">
														<span class="font-normal-style truncate-2">{{ item }}</span>
													</v-card>
												</div><div v-if="key === 'custom4'" class="holding-cell">
													<v-card tile elevation="0" color="transparent">
														<span class="font-normal-style truncate-2">{{ item }}</span>
													</v-card>
												</div>
												<div v-if="key === 'custom5'" class="holding-cell">
													<v-card tile elevation="0" color="transparent">
														<span class="font-normal-style truncate-2">{{ item }}</span>
													</v-card>
												</div>
											</td>
										</tr>
									</template>
								</tbody>
							</template>
							<template v-slot:footer>
								<div class="pagination">
									<v-pagination
										v-model="page"
										:color="color"
										:length="getPaginationTotal(detail['holdings'].length)"
										:total-visible="$vuetify.breakpoint.xs ? 3: 5"
										circle
										@input="onPaginationInput($event, detail)"
									></v-pagination>
									<div class="pagination-text">show</div>
									<div class="pagination-text-page">{{ countPerpage}}/page</div>
									<v-menu offset-y>
										<template v-slot:activator="{ on, attrs }">
											<div v-bind="attrs" v-on="on"><Down class="down"/></div>
										</template>
										<v-list>
											<v-list-item-title v-for="(pageOption, index) in pageOptions" :key="index" class="option-text" style="width: 24px;" @click="onClickOption(pageOption, detail)">
												{{pageOption}}
											</v-list-item-title>
										</v-list>
									</v-menu>
								</div>
							</template>
						</v-data-table>
					</v-expansion-panel-content>
				</v-expansion-panel>
			</v-expansion-panels>
		</template>
		<DialogNotice
			v-if="visible_notice" 
			:visible="visible_notice" 
			:text="notice_text"
			:color="notice_color"
		/>
		<HistoryDialog
			v-if="history_visible"
			:visible="history_visible"
			:refId="history_ref_id"
			@input="history_visible = $event"
		/>
	</div>
</template>

<script>
import ProgressLinear from "@/components/progress/progress_getdata_linear.vue";
import ColumnsTable from "@/components/icons/columns_table.vue";
import Calendar from "@/components/icons/calendar.vue";
import Down from '@/components/icons/down';
import DialogNotice from "@/components/dialogs/notice_dialog.vue";
import HistoryDialog from "@/views/desktop/media/radio_holdings/media_holding_history_dialog";

import moment from 'moment';
import config from "@/config.js";

const Table_Headers = [
	{
		text: '',
		showable: true,
		value: 'checkbox',
		is_ckeck: false,
		width: 50
	},
	{
		text: 'Phase',
		showable: true,
		value: 'phase_desc',
		width: 200
	},
	{
		text: 'Media Outlet',
		showable: true,
		value: 'outlet',
		width: 200
	},
	{
		text: 'Kind',
		showable: true,
		value: 'kind',
		width: 200
	},
	{
		text: 'Station',
		showable: true,
		value: 'station',
		width: 200
	},
	{
		text: 'Media Reference ID',
		showable: true,
		value: 'media_reference_id',
		width: 200
	},
	{
		text: 'Contract Ref',
		showable: true,
		value: 'contract_ref',
		width: 200
	},
	{
		text: 'Booked Date',
		showable: true,
		value: 'booking_start',
		width: 200
	},
	{
		text: 'Booked Day Flags',
		showable: true,
		value: 'booking_day_flags',
		width: 200
	},
	{
		text: 'Duration',
		showable: true,
		value: 'duration',
		width: 200
	},
	{
		text: 'Start Time',
		showable: true,
		value: 'booking_start_time',
		width: 200
	},
	{
		text: 'End Time',
		showable: true,
		value: 'booking_end_time',
		width: 200
	},
	{
		text: 'Supplier rate',
		showable: true,
		value: 'rate_fc',
		width: 200
	},
	{
		text: 'Bill to client',
		showable: true,
		value: 'value_fc',
		width: 200
	},
	{
		text: 'Program Name',
		showable: true,
		value: 'program_name',
		width: 200
	},
	{
		text: 'Position in Break',
		showable: true,
		value: 'pos_in_break',
		width: 200
	},
	{
		text: 'Material Key Number',
		showable: true,
		value: 'material_key_identifier',
		width: 200
	},
	{
		text: 'Priority Modifier',
		showable: true,
		value: 'priority_modifier',
		width: 200
	},
	// {
	// 	text: 'Custom 1',
	// 	showable: true,
	// 	value: 'custom1',
	// 	width: 200
	// },
	// {
	// 	text: 'Custom 2',
	// 	showable: true,
	// 	value: 'custom2',
	// 	width: 200
	// },
	// {
	// 	text: 'Custom 3',
	// 	showable: true,
	// 	value: 'custom3',
	// 	width: 200
	// },
	// {
	// 	text: 'Custom 4',
	// 	showable: true,
	// 	value: 'custom4',
	// 	width: 200
	// },
	// {
	// 	text: 'Custom 5',
	// 	showable: true,
	// 	value: 'custom5',
	// 	width: 200
	// }
];

const Week_Flag = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
const Error_Flag = 'Traffic;';

const Setting_Name = 'RadioNoHolding';

export default {
	name: 'MediaHoldingNoHoldings',
	props: {
		color: {
			type: String,
			default: ''
		},
		fileId: {
			type: Number,
			default: 0
		}
	},
	data() {
		this.week_flag = Week_Flag;

		return {
			loading: false,
			error_msg: '',
			user_id: 0,

			headers: Table_Headers,
			no_holding_list: [],
			panel_details: [],
			panel_details_orignal: [],

			filter_menu_visible: false,
			is_positive_value: false,

			is_down: true,
			columns: Table_Headers.filter(header => { return header.value !== 'checkbox'}),
			select_columns: Table_Headers.filter(header => { return header.value !== 'checkbox'}),

			panel: null,

			delete_totle_ids: [],
			delete_success_ids: [],
			delete_error_ids: [],

			page: 1,
			countPerpage: 10,
			pageOptions: config.pageOptions,

			visible_notice: false,
			notice_text: [],
			notice_color: '#00AAFD',

			history_visible: false,
			history_ref_id: ''
		}
	},
	components: {
		ProgressLinear,
		ColumnsTable,
		Calendar,
		Down,
		DialogNotice,
		HistoryDialog
	},
	async created() {
		await this.getUserId();
		await this.getSettings();

		this.getNoHoldings(this.fileId);
	},
	computed: {
		isFilterDiff() {
			return this.is_positive_value;
		},
		isColumnDiff() {
			let is_diff = false;

			if (this.select_columns.length !== this.columns.length) {
				is_diff = true;
			}

			return is_diff;
		}
	},
	watch: {
		select_columns() {
			const columns = this.select_columns.map(columns => { return columns.value });
			const header_obj = Table_Headers.filter(header => { return columns.includes(header.value) });
			
			header_obj.unshift(Table_Headers[0]);
			this.headers = header_obj;
		},
		is_positive_value() {
			this.refreshVisibleHoldings();
		}
	},
	methods: {
		formatNumber(rate) {
			const number = Number(rate);
			if (!Number.isFinite(number)) return rate;

			return number.toLocaleString('en-AU', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			});
		},
		togglePanel(index) {
			this.panel = this.panel === index ? null : index;
		},
		applyHoldingFilters(holdings) {
			if (!this.is_positive_value) {
				return holdings;
			}

			return holdings.filter(holding => { return Number(holding.rate_fc) > 0 });
		},
		getDateFilteredHoldings(holdings, date_range) {
			return holdings.filter(hold => {
				const start_date = moment(hold.booking_start, 'YYYYMMDD').format('YYYY-MM-DD');
				const is_fall_range = this.isFallRange(start_date, date_range);
				if (is_fall_range) {
					return hold;
				}
			});
		},
		refreshVisibleHoldings() {
			const panel_details_orignal_obj = this.panel_details_orignal.reduce((obj, detail) => {
				obj[detail.id] = JSON.parse(JSON.stringify(detail.holdings));
				return obj;
			}, {});

			this.panel_details.forEach(detail => {
				if (!detail) return;

				const holdings_orignal = panel_details_orignal_obj[detail.id] || [];
				const date_filtered_holdings = detail.date && detail.date.length === 2 ? this.getDateFilteredHoldings(holdings_orignal, detail.date) : holdings_orignal;
				detail.holdings = this.applyHoldingFilters(date_filtered_holdings);
				detail.check = false;
				detail.active_num = 0;
			});
		},
		async getUserId() {
			this.loading = true;

			const url = '/api/user/me';

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						this.user_id = data.id;
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.loading = false;
				});
		},	
		async getSettings() {
			this.loading = true;

			const usid = this.user_id;
			const winname = config.win_name[`${Setting_Name}`];

			const url = `/api/user/${usid}/webwinsetup/${winname}`;

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						if (data.length !== 0) {
							const current_settings = data.filter(d => { return d.user_id === usid });
							const settings_winname = current_settings[0].window_name;
							const settings_windata_json = current_settings[0].windata_json;
							if (settings_winname === winname) {
								const windata = JSON.parse(settings_windata_json);

								const column = windata.column;
								if (column) {
									const columns_orignal = Table_Headers.filter(header => { return header.value !== 'checkbox'});

									const select_columns_view = [];
									columns_orignal.forEach(c => {
										if (column.includes(c.value)) {
											select_columns_view.push(c);
										} 
									});

									this.select_columns = select_columns_view;
								}
							}
						}
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.loading = false;
				});
		},
		updateSettings(win_setup) {
			const usid = this.user_id;
			const winname = config.win_name[`${Setting_Name}`];

			const url = `/api/user/${usid}/webwinsetup/${winname}`;

			const params_obj = {};
			params_obj['value'] = win_setup;

			return new Promise((resolve, reject) => {
				axios
					.post(url, params_obj, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						}
					})
					.then((val) => {
						const json = val.data;
						const { status, data, reason } = json;

						if (status == "OK") {
							resolve(data);
						} else {
							reject(reason);
						}
					})
					.catch((e) => {
						reject(e.message);
					});
			});
		},
		getNoHoldings(file_id, detail_id=0) {
			if (detail_id === 0) {
				this.loading = true;
			} else {
				this.panel_details.forEach(detail => {
					if (detail.id === detail_id) {
						detail.holdings = [];
						detail.table_loading = true;
						detail.check = false;
						detail.active_num = 0;
					}
				});

				this.panel_details_orignal.forEach(detail => {
					if (detail.id === detail_id) {
						detail.holdings = [];
						detail.check = false;
						detail.active_num = 0;
					}
				});
			}
			

			const url = `/api/media/media_planning/import_export/${file_id}/no_holdings`;
			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const {status, data, reason } = val.data;
					if (status == "OK") {
						this.no_holding_list = data;

						/** get panel details */
						const job_id_all = data.map(d => { return d.job_id });
						const unique_job_ids = [...new Set(job_id_all)];

						unique_job_ids.forEach(id => {
							if (detail_id !== 0 && id !== detail_id) return;

							const obj = {};
							const group_arr = data.filter(d => { return d.job_id === id });
							const date_range_by_group = this.getDateRange(group_arr);
					
							group_arr.forEach(group => {
								group['checkbox'] = false;
								group['outlet'] = group.supplier;
								group['kind'] = { id: group.kind.id, code: group.kind.code, display_name: group.kind.name };
								group['booking_day_flags'] = group.booking_day_flags.split("");
								group['duration'] = `${group.booking_duration} sec`;
								group['booking_start_time'] = group.booking_start_time.length === 0 ? '' : `${group.booking_start_time.substring(0,2)}:${group.booking_start_time.substring(2,4)}`;
								group['booking_end_time'] = group.booking_end_time.length === 0 ? '' : `${group.booking_end_time.substring(0,2)}:${group.booking_end_time.substring(2,4)}`;
							});

							group_arr.forEach(group => {
								group.booking_start = this.calculateBookedDate(group.booked_date, group.booking_day_flags);
								group.booking_end = this.calculateBookedEnd(group.booked_date, group.booking_day_flags);
							});

							obj[`id`] = group_arr[0].job_id;
							obj[`holdings`] = group_arr;
							obj[`menu`] = false;
							obj[`date`] = date_range_by_group;
							obj[`month`] = date_range_by_group[0].substring(0, 7);
							obj[`check`] = false;
							obj[`active_num`] = 0;
							obj['job'] = {
								id: group_arr[0].job_id,
								job_code : group_arr[0].job_code,
								job_title: group_arr[0].job_title,
							};

							if (detail_id === 0) {
								const visible_obj = JSON.parse(JSON.stringify(obj));
								visible_obj.holdings = this.applyHoldingFilters(visible_obj.holdings);

								this.panel_details.push(visible_obj);
								this.panel_details_orignal.push(JSON.parse(JSON.stringify(obj)));
							} else {
								this.panel_details.forEach(detail => {
									if (detail.id === detail_id) {
										detail.holdings = this.applyHoldingFilters(JSON.parse(JSON.stringify(obj.holdings)));
										detail.date = obj.date;
										detail.month = obj.month;
										detail.check = false;
										detail.active_num = 0;
									}
								});

								this.panel_details_orignal.forEach(detail => {
									if (detail.id === detail_id) {
										detail.holdings = JSON.parse(JSON.stringify(obj.holdings));
										detail.date = obj.date;
										detail.month = obj.month;
										detail.check = false;
										detail.active_num = 0;
									}
								});
							}
						});

						if (detail_id === 0) {
							this.panel_details.sort((detail_a, detail_b) => {
								const job_code_compare = (detail_a.job.job_code || '').localeCompare(detail_b.job.job_code || '');
								if (job_code_compare !== 0) {
									return job_code_compare;
								}

								return (detail_a.job.job_title || '').localeCompare(detail_b.job.job_title || '');
							});
							this.panel_details_orignal.sort((detail_a, detail_b) => {
								const job_code_compare = (detail_a.job.job_code || '').localeCompare(detail_b.job.job_code || '');
								if (job_code_compare !== 0) {
									return job_code_compare;
								}

								return (detail_a.job.job_title || '').localeCompare(detail_b.job.job_title || '');
							});
							this.panel = 0;
						}

					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
				.finally(() => {
					if (detail_id === 0) {
						this.loading = false;
					} else {
						this.panel_details.forEach(detail => {
							if (detail.id === detail_id) {
								detail.table_loading = false;
							}
						});
					}
				});
		},
		onSelectColumn() {
			const columns = this.select_columns.map(columns => { return columns.value });
			const win_setup_obj = {
				column: columns
			};
			const win_setup = JSON.stringify(win_setup_obj);

			this.updateSettings(win_setup).catch((e) => {
				this.error_msg = e;
			});
		},
		getDateRange(holdings) {
			let date_ramge = [];

			if (holdings.length !== 0) {
				/** merge date */
				const start_date_arr = holdings.map(b => { return b.booking_start });
				const end_date_arr = holdings.map(b => { return b.booking_end });

				start_date_arr.sort((a, b) => {
					const date_a = moment(a, 'YYYYMMDD').format('YYYY-MM-DD');
					const date_b = moment(b, 'YYYYMMDD').format('YYYY-MM-DD');
					return new Date(date_a) - new Date(date_b);
				});
				end_date_arr.sort((a, b) => {
					const date_a = moment(a, 'YYYYMMDD').format('YYYY-MM-DD');
					const date_b = moment(b, 'YYYYMMDD').format('YYYY-MM-DD');
					return new Date(date_a) - new Date(date_b);
				});

				date_ramge = [moment(start_date_arr[0]).format('YYYY-MM-DD'), moment(end_date_arr[end_date_arr.length - 1]).format('YYYY-MM-DD')];
			}

			return date_ramge;
		},
		onDelete(detail) {
			const delete_holdings = detail.holdings.filter(h => { return h.checkbox === true });
			if (delete_holdings.length === 0) return;			
			
			/** init accept_ids */
			const totle_accept_ids_tmp = [];
			delete_holdings.forEach(holding => { totle_accept_ids_tmp.push(holding.id) });
			this.delete_totle_ids = totle_accept_ids_tmp;
			this.delete_success_ids = [];
			this.delete_success_ids_fake = [];
			this.delete_error_ids = [];

			this.notice_text = [`Delete Bookings: ${this.delete_success_ids_fake.length} / ${this.delete_totle_ids.length}`, `Error: ${this.delete_error_ids.length}`];
			this.visible_notice = true;

			const params_arr = delete_holdings.map(holding => { return { id: holding.id } });

			/** fake progress */
			for (let index = 0; index < delete_holdings.length - 1; index++) {
				const fake_holding = delete_holdings[index];
				setTimeout(() => { 
					this.delete_success_ids_fake.push(fake_holding.id);
					this.notice_text = [];
					this.notice_text = [`Delete Bookings: ${this.delete_success_ids_fake.length} / ${this.delete_totle_ids.length}`, `Error: ${this.delete_error_ids.length}`];								
				}, 300);
			}

			this.bulkReverseDelete(params_arr)
				.then(() => {
					const delete_holding_ids = delete_holdings.map(holding => { return holding.id });

					this.delete_success_ids = delete_holding_ids;
					this.delete_success_ids_fake = delete_holding_ids;
					this.delete_error_ids = [];

					this.notice_text = [`Delete Bookings: ${this.delete_success_ids_fake.length} / ${this.delete_totle_ids.length}`, `Error: ${this.delete_error_ids.length}`];
					this.visible_notice = true;
					
					this.checkDeleteFinish(detail.id);
				})
				.catch((reason) => {
					this.error_msg = reason;

					const delete_holding_ids = delete_holdings.map(holding => { return holding.id });

					this.delete_success_ids = [];
					this.delete_success_ids_fake = [];
					this.delete_error_ids = delete_holding_ids;

					this.notice_text = [`Delete Bookings: ${this.delete_success_ids_fake.length} / ${this.delete_totle_ids.length}`, `Error: ${this.delete_error_ids.length}`];
					this.visible_notice = true;
					
					this.checkDeleteFinish(detail.id);
				});
		},
		onCopySelected() {
			let holding_arr = [];

			this.panel_details.forEach(detail => {
				holding_arr = [...holding_arr, ...detail.holdings];
			});

			const active_items = holding_arr.filter(holding => { return holding.checkbox === true });
			let str_arr = [];

			const next_line_print = ['br'];
			// todo how to change the description
			const top_str = `Kindly assist with resolving the following bookings where our records differ from the latest file (date of file):`;
			str_arr.push(top_str);
			str_arr = [...str_arr, ...next_line_print];

			active_items.forEach(item => {
				const print_str = `Media Ref ID: ${item.media_reference_id}`;
				str_arr.push(print_str);

				let date_print = [];
				let flag_print = [];
				let start_print = [];
				let end_print = [];
				let rate_print = [];
						
				for (const [print_key] of Object.entries(item)) {
					if (print_key === 'booking_start') {
						const current_date = `Date: ${moment(item[`${print_key}`]).format('DD MMM YYYY')}`;
						date_print = [current_date];
					} 
					
					if (print_key === 'booking_day_flags') {
						const current_day_flag = `Booked day flags: ${item[`${print_key}`].join('')}`;
						flag_print = [current_day_flag];
					}

					if (print_key === 'booking_start_time') {
						const current_date = `Start time:  ${item[`${print_key}`]}`;
						start_print = [current_date];
					}

					if (print_key === 'booking_end_time') {
						const current_date = `End time:  ${item[`${print_key}`]}`;
						end_print = [current_date];
					}

					if (print_key === 'rate_fc') {
						const current_rate = `Invoiced: ${item.cost_currency ? item.cost_currency.symbol : '$'} ${item[`${print_key}`]}`;
						rate_print = [current_rate];
					}
				}
				str_arr = [...str_arr, ...date_print, ...flag_print, ...start_print, ...end_print, ...rate_print, ...next_line_print];
			})
			
			this.copyCustomFormat(str_arr);
		},
		copyCustomFormat(str_arr) {
			let textContent = '';

			str_arr.forEach(str => {
				if (str === 'br') {
					textContent += `\r\n`;
				} else {
					textContent += `${str}\r\n`;
				}
			});
			
			/** works in many older browsers */
			const textarea = document.createElement("textarea");
			textarea.value = textContent;
			textarea.style.position = "fixed";
			document.body.appendChild(textarea);
			textarea.focus();
			textarea.select();

			try {
				document.execCommand("copy");
				const text = 'Copied successfully.';
				this.notice_text.push(text);
				this.visible_notice = true;
				this.tid = setTimeout(this._close, 2000);
			} catch (err) {
				const text = 'Copied failed.';

				this.notice_text.push(text);
				this.visible_notice = true;
				this.tid = setTimeout(this._close, 2000);
			}

			document.body.removeChild(textarea);

			/** This feature is available only in secure contexts (HTTPS), in some or all supporting browsers. */
			/**
					 try {
						await navigator.clipboard.writeText(textContent);

						const text = 'Copied successfully.';
						this.notice_text.push(text);
						this.visible_notice = true;
						this.tid = setTimeout(this._close, 2000);

					} catch (err) {
						const text = 'Copied failed.';

						this.notice_text.push(text);
						this.visible_notice = true;
						this.tid = setTimeout(this._close, 2000);
					}
			 */
		},
		getDateText(date) {
			return `${moment(date[0]).format('DD MMM')} - ${moment(date[1]).format('DD MMM')}`;
		},
		onDateChange(value_arr, id) {
			if (value_arr.length !== 2) return;
			value_arr.sort();
			const date_range = value_arr;

			const current_panel_detail = this.panel_details_orignal.filter(detail => { return detail.id === id});
			const holdings = JSON.parse(JSON.stringify(current_panel_detail[0].holdings));

			const holdings_filter = this.applyHoldingFilters(this.getDateFilteredHoldings(holdings, date_range));

			this.panel_details.forEach(detail => {
				if (detail.id === id) {
					detail['holdings'] = holdings_filter;
					detail['date'] = date_range;
					detail['menu'] = false;
					detail[`month`] = date_range[0].substring(0, 7);
				}
			});
		},
		onLastWeek(id) {
			const last_week_start = moment().subtract(1, 'weeks').startOf('week').format('YYYY-MM-DD');
			const last_week_end = moment().subtract(1, 'weeks').endOf('week').format('YYYY-MM-DD');
			const date_range = [last_week_start, last_week_end];

			const current_panel_detail = this.panel_details_orignal.filter(detail => { return detail.id === id});
			const holdings = JSON.parse(JSON.stringify(current_panel_detail[0].holdings));

			const holdings_filter = this.applyHoldingFilters(this.getDateFilteredHoldings(holdings, date_range));

			this.panel_details.forEach(detail => {
				if (detail.id === id) {
					detail['holdings'] = holdings_filter;
					detail['date'] = date_range;
					detail['menu'] = false;
					detail[`month`] = date_range[0].substring(0, 7);
				}
			});
		},
		onLastMonth(id) {
			const last_month_start = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
			const last_month_end = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
			const date_range = [last_month_start, last_month_end];

			const current_panel_detail = this.panel_details_orignal.filter(detail => { return detail.id === id});
			const holdings = JSON.parse(JSON.stringify(current_panel_detail[0].holdings));

			const holdings_filter = this.applyHoldingFilters(this.getDateFilteredHoldings(holdings, date_range));

			this.panel_details.forEach(detail => {
				if (detail.id === id) {
					detail['holdings'] = holdings_filter;
					detail['date'] = date_range;
					detail['menu'] = false;
					detail[`month`] = date_range[0].substring(0, 7);
				}
			});
		},
		onCheckBoxAll(is_check, id) {
			const start_index = (this.page - 1) * this.countPerpage;
			const end_index = start_index + this.countPerpage;

			this.panel_details.forEach(detail => {
				if (detail.id === id) {
					detail.holdings.slice(start_index, end_index).forEach(hold => {
						hold.checkbox = is_check;
					});

					const all_selected_holdings = detail.holdings.filter(holding => { return holding.checkbox === true });
					detail.active_num = all_selected_holdings.length;
				}
			});
		},
		onCheckBox(id) {
			this.panel_details.forEach(detail => {
				if (detail.id === id) {
					const start_index = (this.page - 1) * this.countPerpage;
					const end_index = start_index + this.countPerpage;
					const current_page_holdings = detail.holdings.slice(start_index, end_index);
					const selected_holdings = current_page_holdings.filter(holding => { return holding.checkbox === true });

					detail.check = current_page_holdings.length !== 0 && selected_holdings.length === current_page_holdings.length;

					const all_selected_holdings = detail.holdings.filter(holding => { return holding.checkbox === true });
					detail.active_num = all_selected_holdings.length;
				}
			});
		},
		onHistoryClick(item) {
			this.history_ref_id = item;
			this.history_visible = true;
		},
		formatDate(date_str) {
			return `${moment(date_str).format('DD MMM YYYY')}`;
		},
		filterItem(item_obj) {
			let filter_obj = {};

			const header_value_arr = this.headers.map(header => { return header.value });
			header_value_arr.forEach(header => { 
				filter_obj[`${header}`] = item_obj[`${header}`] !== null || item_obj[`${header}`] !== undefined ? item_obj[`${header}`] : '';
			});

			return filter_obj;
		},
		bulkReverseDelete(booking_ids) {
			const url = `/api/media/media_planning/booking/bulk_reverse_delete`;

			return new Promise((resolve, reject) => {
				axios
					.put(url, booking_ids, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						}
					})
					.then((val) => {
						const json = val.data;

						const { status, reason } = json;

						if (status == "OK") {
							resolve(true);
						} else {
							reject(reason);
						}
					})
					.catch((e) => {
						reject(e.message);
					});
			});	

		},
		_deleteBooking(booking_id) {
			const url = `/api/media/media_planning/booking/${booking_id}`;

			return new Promise((resolve, reject) => {
				axios
					.delete(url, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						}
					})
					.then((val) => {
						const json = val.data;

						const { status, reason } = json;

						if (status == "OK") {
							resolve(true);
						} else {
							reject(reason);
						}
					})
					.catch((e) => {
						reject(e.message);
					});
			});	
		},
		calculateBookedDate(booked_date, day_flags) {
			let booking_start = '';

			if (booked_date && day_flags && booked_date.length !== 0 && day_flags.length !== 0) {
				const start_date = moment(booked_date);

				let normalized_day_flags = typeof day_flags === 'string' ? day_flags : day_flags.join('');
				if (normalized_day_flags.length === 6) {
					normalized_day_flags = `${normalized_day_flags}0`;
				}

				if (start_date.isValid() && normalized_day_flags.length === 7) {
					for (let offset = 0; offset < 7; offset++) {
						const current_date = start_date.clone().add(offset, 'days');

						if (normalized_day_flags[current_date.day()] === '1') {
							booking_start = current_date.format('YYYY-MM-DD');
							break;
						}
					}
				}
			}

			return booking_start;
		},
		calculateBookedEnd(booked_date, day_flags) {
			let booking_end = '';

			if (booked_date && day_flags && booked_date.length !== 0 && day_flags.length !== 0) {
				const start_date = moment(booked_date);

				let normalized_day_flags = typeof day_flags === 'string' ? day_flags : day_flags.join('');
				if (normalized_day_flags.length === 6) {
					normalized_day_flags = `${normalized_day_flags}0`;
				}

				if (start_date.isValid() && normalized_day_flags.length === 7) {
					for (let offset = 0; offset < 7; offset++) {
						const current_date = start_date.clone().add(offset, 'days');

						if (normalized_day_flags[current_date.day()] === '1') {
							booking_end = current_date.format('YYYY-MM-DD');
						}
					}
				}
			}

			return booking_end;
		},
		isFallRange(start_date, end_date, date_range) {
			let is_fall_range = false;

			if (date_range.length === 0) {
				is_fall_range = true;
			} else {
				if (moment(date).isSame(date_range[0]) || moment(date).isSame(date_range[1]) || moment(date).isBetween(date_range[0], date_range[1])) {
					is_fall_range = true;
				}
			}

			return is_fall_range
		},
		getPaginationTotal(list_length) {
			return Math.ceil(list_length  / this.countPerpage);
		},
		onPaginationInput(page, detail) {
			const start_index = (page - 1) * this.countPerpage;
			const end_index = start_index + this.countPerpage;
			const current_page_holdings = detail.holdings.slice(start_index, end_index);

			detail.check = current_page_holdings.length !== 0 && current_page_holdings.every(holding => holding.checkbox === true);

			const all_selected_holdings = detail.holdings.filter(holding => { return holding.checkbox === true });
			detail.active_num = all_selected_holdings.length;
		},
		onClickOption(option, detail) {
			this.countPerpage = option;
			const start_index = (this.page - 1) * this.countPerpage;
			const end_index = start_index + this.countPerpage;
			const current_page_holdings = detail.holdings.slice(start_index, end_index);

			detail.check = current_page_holdings.length !== 0 && current_page_holdings.every(holding => holding.checkbox === true);

			const all_selected_holdings = detail.holdings.filter(holding => { return holding.checkbox === true });
			detail.active_num = all_selected_holdings.length;
		},
		checkDeleteFinish(detail_id) {
			const success_num = this.delete_success_ids.length;
			const error_num = this.delete_error_ids.length;
			const finish_num = success_num + error_num;

			if (finish_num === this.delete_totle_ids.length) {
				this.no_holding_list = [];
				this.getNoHoldings(this.fileId, detail_id);
				
				this.visible_notice = false;
				this.notice_text = [];
			}
		},
		errorMessageFormat(msg) {
			let msg_str = msg;

			if (msg_str.includes(Error_Flag)) {
				msg_str = (msg_str.split(Error_Flag))[1];
			}
			
			return msg_str;
		},
		_close() {
			this.visible_notice = false;
			this.notice_text = [];
		},
	}
}
</script>

<style lang="scss" scoped>
.file-list-title {
  font-family: Roboto;
  font-weight: 700;
  font-size: 20px;
  line-height: 32px;
  letter-spacing: -0.5px;
  color: #4742C6;
}
 .file-list-text {
	font-family: Roboto;
	font-weight: 400;
	font-size: 14px;
	line-height: 20px;
	letter-spacing: 0.25px;
	color: #192A3E;
}
.font-normal-style {
	font-family: Roboto;
	font-weight: 400;
	font-size: 14px;
	letter-spacing: 0.5px;
}
.font-bold-style {
	font-family: Roboto;
	font-weight: 500;
	font-size: 14px;
	letter-spacing: 0.5px;
}
.font-header-style {
	color: #192A3E;
}
.header-background-color {
	background-color: #EAEAEA;
}
.filter-menu-wrap {
	background-color: #FFFFFF;
}
.filter-menu-checkbox {
	margin-top: 0;
	padding-top: 0;
	min-height: 32px;
}
.filter-menu-label {
	font-family: Roboto;
	font-weight: 400;
	font-size: 14px;
	line-height: 20px;
	letter-spacing: 0.25px;
	color: #192A3E;
}
.holding-cell {
	width: auto;
	min-width: 120px;
	max-width: 240px;
}
.holding-cell .row {
	min-width: 0;
	width: 100%;
}
.holding-cell .long-text {
	display: block;
	min-width: 0;
	max-width: 100%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.holding-cell-checkbox {
	min-width: 50px;
	max-width: 50px;
}
.sticky-checkbox-column {
	position: sticky;
	left: 0;
	z-index: 2;
}
.sticky-checkbox-cell {
	background-color: #FAFAFF;
}
.table-header-row {
	align-items: center;
	flex-wrap: nowrap;
	min-height: 60px;
}
.panel-icon {
	order: 0;
}
.panel-header {
	order: 1;
}
.truncate-2 {
  overflow: hidden;
	text-overflow: ellipsis;
	white-space: initial;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
}
.pagination {
	display: flex;
	flex-flow: row nowrap;
	justify-content: flex-start;
	align-items: center;
	background-color: rgba(25, 42, 62, 0.1);
	.pagination-text {
		font-family: Roboto;
		font-style: normal;
		font-weight: normal;
		font-size: 12px;
		line-height: 16px;
		color: rgba(25, 42, 62, 0.5);
	}
	.pagination-text-page {
		font-family: Roboto;
		font-style: normal;
		font-weight: normal;
		font-size: 12px;
		line-height: 16px;
		color: #192A3E;
		margin: 0 8px;
	}
	.down {
		width: 12px;
		height: 12px;
		margin-top: 10px;
		&:hover {
			cursor: pointer;
		}
	}
}
.option-text {
	margin: 0 4px;
	font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	font-size: 13px;
	color: #192A3E;
	&:hover {
		cursor: pointer;
	}
}
.panel-toggle-target {
	cursor: pointer;
}

::v-deep {
	.no-header-hover.v-expansion-panel-header,
	.no-header-hover.v-expansion-panel-header:hover {
		cursor: default;
	}
	.no-header-hover.v-expansion-panel-header:hover::before {
		opacity: 0;
	}
	.v-data-table__wrapper {
		overflow-x: auto;
	}
	table {
		width: max-content;
		min-width: 100%;
		table-layout: auto;
	}
	th,
	td {
		width: auto !important;
		white-space: nowrap;
		vertical-align: middle;
	}
	.v-expansion-panel-content__wrap {
		padding: 0 16px 0 !important;
	}
	.v-pagination__navigation {
		width: 20px;
		height: 20px;
	}
	.v-pagination__item {
		min-width: 26px;
		height: 26px;
	}
}
</style>
